/**课程模块 */
import request from '../request/http';
/**新增课程 */
export function SaveCourse(data){
    return request({
        url: '/sp/course/saveCourse',
        method: 'post',
        data
    })
}
/**修改课程 */
export function UpdateCourse(data){
    return request({
        url: '/sp/course/updateCourse',
        method: 'post',
        data
    })
}
/**根据id获取课程详情 */
export function GetCourseById(data){
    return request({
        url: '/sp/course/getCourseById',
        method: 'post',
        data
    })
}
/**删除课程 */
export function DeleteCourse(data){
    return request({
        url: '/sp/course/deleteCourse',
        method: 'post',
        data
    })
}
/**分页查询课程 */
export function PageList(data){
    return request({
        url: '/sp/course/pageList',
        method: 'post',
        data
    })
}
/**发布课程 */
export function ReleaseCourse(data){
    return request({
        url: '/sp/course/releaseCourse',
        method: 'post',
        data
    })
}
/**课程发布审核 */
export function CourseReleaseAudit(data){
    return request({
        url: '/sp/course/courseReleaseAudit',
        method: 'post',
        data
    })
}
/**分页查询课程发布审核记录 */
export function PageQueryCourseAudit(data){
    return request({
        url: '/sp/course/pageQueryCourseAudit',
        method: 'post',
        data
    })
}
/**分页查询我的课程发布审核记录 */
export function PageQueryMyCourseAudit(data){
    return request({
        url: '/sp/course/pageQueryMyCourseAudit',
        method: 'post',
        data
    })
}
/**取消发布 */
export function CancelReleaseCourse(data){
    return request({
        url: '/sp/course/cancelReleaseCourse',
        method: 'post',
        data
    })
}
/**查询课程详情 */
export function QueryCourseDetail(data){
    return request({
        url: '/sp/course/queryCourseDetail',
        method: 'post',
        data
    })
}
/**查询课程详情数据统计 */
export function GetCourseDataStatistics(data){
    return request({
        url: '/sp/course/getCourseDataStatistics',
        method: 'post',
        data
    })
}
/**分页查询已发布的课程 */
export function ReleasePageList(data){
    return request({
        url: '/sp/course/releasePageList',
        method: 'post',
        data
    })
}
/**获取课程学习状态 */
export function GetCourseStudyStatus(data){
    return request({
        url: '/sp/course/getCourseStudyStatus',
        method: 'post',
        data
    })
}
/**查询拥有权限的课程 */
export function PageQueryPermissionList(data){
    return request({
        url: '/sp/course/pageQueryPermissionList',
        method: 'post',
        data
    })
}
/**分页查询课程学习记录 */
export function PageQueryCourseStudyRecord(data){
    return request({
        url: '/sp/course/pageQueryCourseStudyRecord',
        method: 'post',
        data
    })
}
/**分页查询课程使用记录 */
export function PageQueryCourseUseRecord(data){
    return request({
        url: '/sp/course/pageQueryCourseUseRecord',
        method: 'post',
        data
    })
}
/**查询课程期数 */
export function QueryCourseOpenPeriods(data){
    return request({
        url: '/sp/course/queryCourseOpenPeriods?courseId='+data,
        method: 'post',
    })
}
/**获取课程学习租户列表 */
export function QueryCourseStudyTenantList(data){
    return request({
        url: '/sp/course/queryCourseStudyTenantList?courseId='+data,
        method: 'post',
    })
}
/**分页查询课程学习次数 */
export function PageQueryCourseStudyCount(data){
    return request({
        url: '/sp/course/pageQueryCourseStudyCount',
        method: 'post',
        data
    })
}
/**分页查询课程学习详情 */
export function PageQueryCourseStudyDetails(data){
    return request({
        url: '/sp/course/pageQueryCourseStudyDetails',
        method: 'post',
        data
    })
}
/**结束课程 */
export function EndCourse(data){
    return request({
        url: '/sp/course/endCourse',
        method: 'post',
        data
    })
}
/**获取课程学习学生 */
export function GetCourseStudyUser(data){
    return request({
        url: '/sp/course/getCourseStudyUser',
        method: 'post',
        data
    })
}